export enum CommunicationType {
    VisitSummary = 1,
    MedicalHistory = 2,
    RabiesCertificate = 3,
    LabResult = 4,
    Prescription = 5,
    VisitCompletionSummary = 6,
    VisitConsent = 7,
    IntakeNotification = 8,
    CancelledClinic = 9,
    CancelledClinicOpsLeader = 10,
    AppointmentManagementVerification = 11,
    TreatmentPlanConsent = 12,
    Invoice = 13,
    Estimate = 14,
    HospitalPatientChart = 15,
    DischargeSummary = 16,
    DischargeAgainstMedicalAdviceConsent = 17,
    ClientConsent = 18,
    DentalExtractionConsent = 19,
    EuthanasiaConsent = 20,
    TreatmentConsent = 21,
    SurgeryConsent = 22,
    AnesthesiaMonitoring = 23,
    WellnessAndPreventativeCareSummary = 24,
    HospitalPrescriptions = 25,
    HospitalVisitPrescriptions = 26
}

export namespace CommunicationType {
    export const displayName = (communicationType: CommunicationType) => {
        switch (communicationType) {
            case CommunicationType.VisitSummary: return "Visit Summary";
            case CommunicationType.MedicalHistory: return "Medical History";
            case CommunicationType.RabiesCertificate: return "Rabies Certificate";
            case CommunicationType.LabResult: return "Lab Result";
            case CommunicationType.Prescription: return "Prescription";
            case CommunicationType.VisitCompletionSummary: return "Visit Completion";
            case CommunicationType.VisitConsent: return "Visit Consent";
            case CommunicationType.IntakeNotification: return "Intake Notification";
            case CommunicationType.CancelledClinic: return "Cancelled Clinic";
            case CommunicationType.CancelledClinicOpsLeader: return "Cancelled Clinic Ops Leader";
            case CommunicationType.AppointmentManagementVerification: return "Appointment Management Verification";
            case CommunicationType.TreatmentPlanConsent: return "Treatment Plan Consent";
            case CommunicationType.Invoice: return "Visit Invoice";
            case CommunicationType.Estimate: return "Estimate";
            case CommunicationType.HospitalPatientChart: return "Patient Chart";
            case CommunicationType.DischargeSummary: return "Discharge Summary";
            case CommunicationType.AnesthesiaMonitoring: return "Anesthesia Monitoring";
            case CommunicationType.WellnessAndPreventativeCareSummary: return "Wellness And Preventative Care Summary";
            default: return "";
        }
    }
}
